module.exports = __webpack_public_path__ + "static/media/poster_background.f27e92b2.png";